<template>
  <div>
    <div
      @click="openImage"
      class="message__block message__block--multimedia"
      role="button">
      <img
        class="message__block-content"
        v-lazy="previewUrl"/>
    </div>
    <message-text :message="message" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  CAROUSEL_OPEN,
} from '@/eventTypes';
import EventBus from '@/eventBus';

export default {
  props: {
    message: {
      required: true,
      type: Object,
    },
  },
  components: {
    MessageText: () => import('@/components/message/MessageText.vue'),
  },
  computed: {
    ...mapState(['token']),
    tokenQuery() {
      return `?token=${this.token}`;
    },
    multimedia() {
      return this.message.multimedia ?? {};
    },
    fullUrl() {
      return this.multimedia.file ? `${this.multimedia.file}${this.tokenQuery}` : '';
    },
    thumbUrl() {
      return this.multimedia.thumbnail ? `${this.multimedia.thumbnail}${this.tokenQuery}` : '';
    },
    hasThumbnail() {
      return this.thumbUrl.length > 0;
    },
    previewUrl() {
      return this.hasThumbnail ? this.thumbUrl : this.fullUrl;
    },
  },
  methods: {
    openImage() {
      const payload = {
        url: this.fullUrl,
        type: 'image',
      };

      EventBus.$emit(CAROUSEL_OPEN, payload);
    },
  },
};
</script>
